import React, { useState, useEffect } from "react";
import { Box, Card, IconButton, Icon, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { get, postNoResponse } from "utils/WebService";
import { useUser } from "context/UserContext";
import { useMaterialUIController } from "context";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDSnackbar from "components/MDSnackbar";
import MDButton from "components/MDButton";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import Contratos from "./Contratos";
import Historico from "./Historico";
import Acordos from "./Acordos";

export default function Honorarios({ formRef, recordId, isViewOnly, pendingContratos = [], setPendingContratos, changeTab, onDataUpdated, refreshKey, preloadedDevedor, preloadedContratos, preloadedAcordos, preloadedHistoricos }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [fichas, setFichas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeFichaId, setActiveFichaId] = useState(null);
    const [tabValue, setTabValue] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };
    const { userPerfils, userFunctionalities } = useUser();
    
    // Roles & Permissões
    const canCreate = userFunctionalities && userFunctionalities.includes("c050_C");
    const canEdit = userFunctionalities && userFunctionalities.includes("c050_U");
    const isAdminOrGestor = Array.isArray(userPerfils) && userPerfils.some(p => p?.tipoPerfil === 4 || p?.tipoPerfil === 6 || p?.nome === 'Administrador' || p?.nome === 'Suporte' || p === 'Administrador' || p === 'Suporte' || p?.nome === 'Gestor' || p === 'Gestor');
    const isSupervisorOrCoordenador = Array.isArray(userPerfils) && userPerfils.some(p => p?.tipoPerfil === 3 || p?.nome === 'Supervisor' || p === 'Supervisor' || p?.nome === 'Coordenador' || p === 'Coordenador');
    const isOperador = !canCreate && !canEdit && !isAdminOrGestor && !isSupervisorOrCoordenador;

    // Form States
    const [editForm, setEditForm] = useState({ carteiraId: "", statusId: "", usuarioId: "", marcacoesIds: [] });
    const [carteirasOptions, setCarteirasOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [usuariosOptions, setUsuariosOptions] = useState([]);
    const [marcacoesOptions, setMarcacoesOptions] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    
    // Add Modal States (Honorário Avulso)
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [addForm, setAddForm] = useState({
        carteiraId: "",
        statusId: "",
        usuarioId: "",
        marcacoesIds: [],
        titulo: "Honorários Advocatícios",
        valorOriginal: "",
        vencimento: new Date().toISOString().split("T")[0],
        tipoHonorario: 5,
        descricao: ""
    });

    const tipoHonorarioOptions = [
        { id: 1, nome: "Sucumbenciais" },
        { id: 2, nome: "Contratuais" },
        { id: 3, nome: "Iniciais" },
        { id: 4, nome: "Finais" },
        { id: 5, nome: "Outros" },
    ];

    // Snackbar States
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    const loadFichas = () => {
        if (preloadedDevedor !== undefined) {
            if (preloadedDevedor && preloadedDevedor.fichas) {
                const honorarios = preloadedDevedor.fichas.filter(f => f.isHonorario === true || f.cbIsHonorario === true);
                setFichas(honorarios);
            } else {
                setFichas([]);
            }
            setLoading(false);
            return;
        }

        setLoading(true);
        get(`/devedor/by-id/${recordId}`)
            .then(res => {
                if (res && res.fichas) {
                    const honorarios = res.fichas.filter(f => f.isHonorario === true || f.cbIsHonorario === true);
                    setFichas(honorarios);
                }
            })
            .catch(err => console.error("Erro ao carregar fichas de honorários", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (recordId || preloadedDevedor) {
            loadFichas();
        }
    }, [recordId, refreshKey, preloadedDevedor]);

    const activeFicha = activeFichaId ? fichas.find(f => f.id === activeFichaId || f.rawId === activeFichaId) : null;

    useEffect(() => {
        if (activeFicha) {
            setEditForm({
                carteiraId: activeFicha.idCarteira || activeFicha.carteiraId || "",
                statusId: activeFicha.idStatusFicha || activeFicha.statusId || "",
                usuarioId: activeFicha.idUsuarioDono || activeFicha.usuarioId || "",
                marcacoesIds: activeFicha.marcacoesIds || (activeFicha.tbMarcacoesEspeciais ? activeFicha.tbMarcacoesEspeciais.map(m => m.cvId || m.id) : [])
            });
            
            if (carteirasOptions.length === 0) {
                get("/carteira/list-all").then(res => {
                    let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                    setCarteirasOptions(list);
                }).catch(() => {});
            }
            if (statusOptions.length === 0) {
                get("/status-ficha/list-all").then(res => {
                    let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                    setStatusOptions(list);
                }).catch(() => {});
            }
            if (usuariosOptions.length === 0) {
                get("/users/list-all-operators").then(res => setUsuariosOptions(res?.list || res?.data || (Array.isArray(res) ? res : []))).catch(() => {});
            }
            if (marcacoesOptions.length === 0) {
                get("/marcacoes").then(res => {
                    let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                    setMarcacoesOptions(list.filter(m => m.cvAlvo === 1 || m.cvAlvo === 3));
                }).catch(() => {});
            }
        }
    }, [activeFichaId, fichas]);

    const handleBackToGrid = () => {
        setActiveFichaId(null);
        setTabValue(0);
    };

    const handleOpenDetail = (ficha) => {
        setActiveFichaId(ficha.id || ficha.rawId);
        setTabValue(0);
    };

    const handleSaveEdit = () => {
        if (!activeFicha) return;
        setIsSaving(true);
        postNoResponse(`/devedor/carteira/update/${activeFicha.id || activeFicha.rawId}`, editForm)
            .then(() => {
                setSbMessage("Ficha de honorários atualizada com sucesso!");
                setSuccessSB(true);
                if (recordId) {
                    get(`/devedor/by-id/${recordId}`).then(res => {
                        if (res && res.fichas) {
                            const honorarios = res.fichas.filter(f => f.isHonorario === true || f.cbIsHonorario === true);
                            setFichas(honorarios);
                        }
                    }).catch(() => loadFichas());
                } else {
                    loadFichas();
                }
                if (onDataUpdated) onDataUpdated();
            })
            .catch(() => {
                setSbMessage("Erro ao atualizar ficha de honorários.");
                setErrorSB(true);
            })
            .finally(() => setIsSaving(false));
    };

    const handleOpenAdd = () => {
        setAddForm({
            carteiraId: "",
            statusId: "",
            usuarioId: "",
            marcacoesIds: [],
            titulo: "Outros",
            valorOriginal: "",
            vencimento: new Date().toISOString().split("T")[0],
            tipoHonorario: 5,
            descricao: ""
        });
        
        if (carteirasOptions.length === 0) {
            get("/carteira/list-all").then(res => {
                let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                setCarteirasOptions(list);
            }).catch(() => {});
        }
        if (statusOptions.length === 0) {
            get("/status-ficha/list-all").then(res => {
                let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                setStatusOptions(list);
            }).catch(() => {});
        }
        if (usuariosOptions.length === 0) {
            get("/users/list-all-operators").then(res => setUsuariosOptions(res?.list || res?.data || (Array.isArray(res) ? res : []))).catch(() => {});
        }
        if (marcacoesOptions.length === 0) {
            get("/marcacoes").then(res => {
                let list = res?.list || res?.data || (Array.isArray(res) ? res : []);
                setMarcacoesOptions(list.filter(m => m.cvAlvo === 1 || m.cvAlvo === 3));
            }).catch(() => {});
        }

        setAddModalOpen(true);
    };

    const handleSaveAdd = () => {
        if (!addForm.carteiraId) {
            setSbMessage("Por favor, selecione uma Carteira.");
            setErrorSB(true);
            return;
        }
        if (!addForm.valorOriginal || parseFloat(addForm.valorOriginal) <= 0) {
            setSbMessage("Por favor, informe um valor válido para o débito de honorários.");
            setErrorSB(true);
            return;
        }

        setIsSaving(true);
        postNoResponse("/devedor/honorario-avulso/save", {
            idDevedor: recordId,
            carteiraId: addForm.carteiraId,
            statusId: addForm.statusId,
            usuarioId: addForm.usuarioId,
            marcacoesIds: addForm.marcacoesIds,
            titulo: addForm.titulo || "Honorários Advocatícios",
            valorOriginal: addForm.valorOriginal,
            vencimento: addForm.vencimento,
            tipoHonorario: addForm.tipoHonorario || 5,
            descricao: addForm.descricao
        })
        .then(() => {
            setSbMessage("Honorário avulso cadastrado com sucesso!");
            setSuccessSB(true);
            setAddModalOpen(false);
            if (recordId) {
                get(`/devedor/by-id/${recordId}`).then(res => {
                    if (res && res.fichas) {
                        const honorarios = res.fichas.filter(f => f.isHonorario === true || f.cbIsHonorario === true);
                        setFichas(honorarios);
                    }
                }).catch(() => loadFichas());
            } else {
                loadFichas();
            }
            if (onDataUpdated) onDataUpdated();
        })
        .catch((err) => {
            console.error("Erro ao cadastrar honorário", err);
            setSbMessage("Erro ao cadastrar honorário avulso.");
            setErrorSB(true);
        })
        .finally(() => setIsSaving(false));
    };

    const handleDelete = (id) => {
        if (window.confirm("Deseja realmente excluir esta ficha de honorários? Todos os contratos atrelados a ela também serão apagados. O acordo formalizado ficará sem os honorários.")) {
            postNoResponse(`/devedor/carteira/delete/${id}`, {})
                .then(() => {
                    setSbMessage("Ficha excluída com sucesso!");
                    setSuccessSB(true);
                    if (onDataUpdated) onDataUpdated();
                    else loadFichas();
                })
                .catch(() => {
                    setSbMessage("Erro ao excluir ficha.");
                    setErrorSB(true);
                });
        }
    };

    const columns = [
        { 
            header: "ID", 
            accessorKey: "rawId", 
            align: "center", 
            width: "10%" 
        },
        { 
            header: "Carteira", 
            accessorKey: "nomeCarteira", 
            align: "left",
            cell: ({ row }) => (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {row.original.nomeCarteira || "Não informada"}
                </MDTypography>
            )
        },
        { 
            header: "Status", 
            accessorKey: "nomeStatusFicha", 
            align: "left",
            cell: ({ row }) => (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {row.original.nomeStatusFicha || "Sem status"}
                </MDTypography>
            )
        },
        { 
            header: "Propriedade", 
            accessorKey: "nomeUsuarioDono", 
            align: "left",
            cell: ({ row }) => (
                <MDTypography variant="caption" color="text" fontWeight="medium">
                    {row.original.nomeUsuarioDono || "Sem responsável"}
                </MDTypography>
            )
        },
        {
            header: "Ações",
            accessorKey: "actions",
            align: "center",
            cell: ({ row }) => (
                <MDBox display="flex" justifyContent="center">
                    <IconButton onClick={() => handleOpenDetail(row.original)} color="info" size="small" title="Visualizar">
                        <Icon>visibility</Icon>
                    </IconButton>
                    <IconButton onClick={() => handleOpenDetail(row.original)} color="warning" size="small" title="Editar">
                        <Icon>edit</Icon>
                    </IconButton>
                    {(!isOperador && !isViewOnly) && (
                        <IconButton onClick={() => handleDelete(row.original.id)} color="error" size="small" title="Excluir">
                            <Icon>delete</Icon>
                        </IconButton>
                    )}
                </MDBox>
            )
        }
    ];

    return (
        <MDBox mt={2}>
            {activeFichaId ? (
                <Card id="honorarios-ficha-detalhe" sx={{ boxShadow: "none" }}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2} flexWrap="wrap" gap={1}>
                        <MDButton 
                            variant="outlined" 
                            color="secondary" 
                            size="small"
                            onClick={handleBackToGrid}
                            sx={{
                                color: darkMode ? "#ffffff !important" : undefined,
                                borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined
                            }}
                        >
                            <Icon sx={{ mr: 0.5 }}>arrow_back</Icon> Voltar
                        </MDButton>

                        <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                            <MDButton 
                                variant="contained" 
                                color="info" 
                                size="small" 
                                onClick={handleOpenAdd}
                                sx={{
                                    backgroundColor: darkMode ? "#007bff !important" : undefined,
                                    color: "#ffffff !important",
                                    fontWeight: "bold",
                                    boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
                                    "&:hover": {
                                        backgroundColor: darkMode ? "#0069d9 !important" : undefined
                                    }
                                }}
                            >
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar Honorário Avulso
                            </MDButton>
                        </MDBox>
                    </MDBox>
                    
                    <MDBox sx={{ width: '100%', px: 2, mb: 4 }}>
                        <MDBox sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleChangeTab} aria-label="honorarios-tabs">
                                <Tab label="Dados" value={0} sx={{ fontSize: 12 }} />
                                <Tab label="Contratos" value={1} sx={{ fontSize: 12 }} />
                                <Tab label="Histórico" value={2} sx={{ fontSize: 12 }} />
                                <Tab label="Acordos" value={3} sx={{ fontSize: 12 }} />
                            </Tabs>
                        </MDBox>

                        <MDBox mt={3}>
                            <div role="tabpanel" hidden={tabValue !== 0}>
                                {tabValue === 0 && activeFicha && (
                                    <Card sx={{ p: 3, boxShadow: "none", bgcolor: darkMode ? "#4B4F5C" : "#fafafa", borderRadius: "12px", border: `1px solid ${darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0"}` }}>
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
                                            <MDTypography variant="h6" fontWeight="medium" color={darkMode ? "white" : "dark"}>
                                                Dados da Ficha de Honorários #{activeFicha.rawId || activeFicha.id}
                                            </MDTypography>
                                        </MDBox>

                                        <Grid container spacing={3} alignItems="flex-start">
                                            <Grid item xs={12} sm={6} md={3}>
                                                <MDBox>
                                                    <MDTypography 
                                                        variant="caption" 
                                                        fontWeight="bold" 
                                                        color={darkMode ? "white" : "text"} 
                                                        sx={{ display: "flex", alignItems: "center", minHeight: "24px", mb: 1 }}
                                                    >
                                                        Carteira
                                                    </MDTypography>
                                                    <MDSelect
                                                        isMulti={false}
                                                        getOptionValue={(option) => option.id}
                                                        getOptionLabel={(option) => option.nome}
                                                        placeholder="Selecione..."
                                                        value={carteirasOptions.find(c => String(c.id) === String(editForm.carteiraId)) || (activeFicha.nomeCarteira ? { id: activeFicha.idCarteira, nome: activeFicha.nomeCarteira } : null)}
                                                        options={carteirasOptions}
                                                        onChange={(val) => setEditForm({ ...editForm, carteiraId: val ? val.id : "" })}
                                                        isDisabled={!isAdminOrGestor}
                                                    />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={3}>
                                                <MDBox>
                                                    <MDTypography 
                                                        variant="caption" 
                                                        fontWeight="bold" 
                                                        color={darkMode ? "white" : "text"} 
                                                        sx={{ display: "flex", alignItems: "center", minHeight: "24px", mb: 1 }}
                                                    >
                                                        Status da Ficha
                                                    </MDTypography>
                                                    <MDSelect
                                                        isMulti={false}
                                                        getOptionValue={(option) => option.id}
                                                        getOptionLabel={(option) => option.nome || option.ccNome}
                                                        placeholder="Selecione..."
                                                        value={statusOptions.find(s => String(s.id) === String(editForm.statusId)) || (activeFicha.nomeStatusFicha ? { id: activeFicha.idStatusFicha, nome: activeFicha.nomeStatusFicha } : null)}
                                                        options={statusOptions}
                                                        onChange={(val) => setEditForm({ ...editForm, statusId: val ? val.id : "" })}
                                                        isDisabled={false}
                                                    />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={3}>
                                                <MDBox>
                                                    <MDTypography 
                                                        variant="caption" 
                                                        fontWeight="bold" 
                                                        color={darkMode ? "white" : "text"} 
                                                        sx={{ display: "flex", alignItems: "center", minHeight: "24px", mb: 1 }}
                                                    >
                                                        Responsável (Propriedade)
                                                    </MDTypography>
                                                    <MDSelect
                                                        isMulti={false}
                                                        getOptionValue={(option) => option.id}
                                                        getOptionLabel={(option) => option.nome}
                                                        placeholder="Selecione..."
                                                        value={usuariosOptions.find(u => String(u.id) === String(editForm.usuarioId)) || (activeFicha.nomeUsuarioDono ? { id: activeFicha.idUsuarioDono, nome: activeFicha.nomeUsuarioDono } : null)}
                                                        options={usuariosOptions}
                                                        onChange={(val) => setEditForm({ ...editForm, usuarioId: val ? val.id : "" })}
                                                        isDisabled={isOperador || isViewOnly}
                                                    />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={3}>
                                                <MDBox>
                                                    <MDTypography 
                                                        variant="caption" 
                                                        fontWeight="bold" 
                                                        color={darkMode ? "white" : "text"} 
                                                        sx={{ display: "flex", alignItems: "center", minHeight: "24px", mb: 1 }}
                                                    >
                                                        Marcação Especial
                                                    </MDTypography>
                                                    <MDSelect
                                                        isMulti={true}
                                                        getOptionValue={(option) => option.cvId}
                                                        getOptionLabel={(option) => option.ccNome}
                                                        placeholder="Selecione..."
                                                        value={marcacoesOptions.filter(m => editForm.marcacoesIds && editForm.marcacoesIds.includes(m.cvId))}
                                                        options={marcacoesOptions}
                                                        onChange={(selected) => setEditForm({ ...editForm, marcacoesIds: selected ? selected.map(s => s.cvId) : [] })}
                                                        isDisabled={isOperador || isViewOnly}
                                                    />
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} display="flex" justifyContent="flex-end" mt={3} pt={2} sx={{ borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0e0e0" }}>
                                                <MDButton 
                                                    variant="contained" 
                                                    color="info" 
                                                    onClick={handleSaveEdit}
                                                    disabled={isSaving}
                                                    sx={{
                                                        backgroundColor: darkMode ? "#007bff !important" : undefined,
                                                        color: "#ffffff !important",
                                                        fontWeight: "bold",
                                                        boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
                                                        "&:hover": {
                                                            backgroundColor: darkMode ? "#0069d9 !important" : undefined
                                                        }
                                                    }}
                                                >
                                                    {isSaving ? <CircularProgress size={18} color="inherit" /> : "Salvar Dados"}
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                )}
                            </div>
                            <div role="tabpanel" hidden={tabValue !== 1}>
                                {tabValue === 1 && (
                                    <Contratos 
                                        formRef={formRef} 
                                        recordId={recordId} 
                                        idDevedorCarteira={activeFichaId}
                                        isViewOnly={isViewOnly} 
                                        pendingContratos={pendingContratos} 
                                        setPendingContratos={setPendingContratos} 
                                        changeTab={handleChangeTab} 
                                        onDataUpdated={onDataUpdated} 
                                        isHonorariosTab={true}
                                        preloadedContratos={preloadedContratos}
                                        preloadedAcordos={preloadedAcordos}
                                    />
                                )}
                            </div>
                            <div role="tabpanel" hidden={tabValue !== 2}>
                                {tabValue === 2 && (
                                    <Historico 
                                        recordId={recordId} 
                                        isViewOnly={isViewOnly} 
                                        idDevedorCarteira={activeFichaId} 
                                        preloadedDevedor={preloadedDevedor}
                                        preloadedHistoricos={preloadedHistoricos}
                                        isHonorariosTab={true}
                                    />
                                )}
                            </div>
                            <div role="tabpanel" hidden={tabValue !== 3}>
                                {tabValue === 3 && (
                                    <Acordos 
                                        recordId={recordId} 
                                        isViewOnly={isViewOnly} 
                                        idDevedorCarteira={activeFichaId} 
                                        changeTab={handleChangeTab} 
                                        isHonorariosTab={true} 
                                        onDataUpdated={onDataUpdated} 
                                        preloadedAcordos={preloadedAcordos}
                                    />
                                )}
                            </div>
                        </MDBox>
                    </MDBox>
                </Card>
            ) : (
                <>
                    <MDBox display="flex" justifyContent="flex-end" mb={2}>
                        <MDButton 
                            variant="contained" 
                            color="info" 
                            size="small" 
                            onClick={handleOpenAdd}
                            sx={{
                                backgroundColor: darkMode ? "#007bff !important" : undefined,
                                color: "#ffffff !important",
                                fontWeight: "bold",
                                boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
                                "&:hover": {
                                    backgroundColor: darkMode ? "#0069d9 !important" : undefined
                                }
                            }}
                        >
                            <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar Honorário Avulso
                        </MDButton>
                    </MDBox>

                    <DataTable
                        columnData={columns}
                        data={fichas}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                    />
                </>
            )}

            {/* Modal de Cadastrar Honorário Avulso */}
            <Dialog 
                open={addModalOpen} 
                onClose={() => !isSaving && setAddModalOpen(false)} 
                maxWidth="md" 
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                        color: darkMode ? "#ffffff" : "inherit"
                    }
                }}
            >
                <DialogTitle sx={{ color: darkMode ? "#ffffff" : "inherit" }}>
                    Cadastrar Honorário Avulso (Ficha & Débito)
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : undefined }}>
                    <Grid container spacing={2} alignItems="flex-start">
                        {/* Seção 1: Configuração da Ficha */}
                        <Grid item xs={12}>
                            <MDTypography variant="button" fontWeight="bold" color="info">
                                1. Configuração da Ficha de Honorários
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "text"} display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Carteira *</MDTypography>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome}
                                    placeholder="Selecione..."
                                    value={carteirasOptions.find(c => c.id === addForm.carteiraId) || null}
                                    options={carteirasOptions}
                                    onChange={(val) => setAddForm({ ...addForm, carteiraId: val ? val.id : "" })}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "text"} display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Status da Ficha</MDTypography>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome || option.ccNome}
                                    placeholder="Selecione..."
                                    value={statusOptions.find(s => String(s.id) === String(addForm.statusId)) || null}
                                    options={statusOptions}
                                    onChange={(val) => setAddForm({ ...addForm, statusId: val ? val.id : "" })}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "text"} display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Responsável (Propriedade)</MDTypography>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome}
                                    placeholder="Selecione..."
                                    value={usuariosOptions.find(u => u.id === addForm.usuarioId) || null}
                                    options={usuariosOptions}
                                    onChange={(val) => setAddForm({ ...addForm, usuarioId: val ? val.id : "" })}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "text"} display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Marcação Especial</MDTypography>
                                <MDSelect
                                    isMulti={true}
                                    getOptionValue={(option) => option.cvId}
                                    getOptionLabel={(option) => option.ccNome}
                                    placeholder="Selecione..."
                                    value={marcacoesOptions.filter(m => addForm.marcacoesIds && addForm.marcacoesIds.includes(m.cvId))}
                                    options={marcacoesOptions}
                                    onChange={(selected) => setAddForm({ ...addForm, marcacoesIds: selected ? selected.map(s => s.cvId) : [] })}
                                />
                            </MDBox>
                        </Grid>

                        {/* Seção 2: Cadastro do Débito */}
                        <Grid item xs={12} pt={2}>
                            <MDTypography variant="button" fontWeight="bold" color="info">
                                2. Cadastro do Débito de Honorários
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color={darkMode ? "white" : "text"} display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Tipo de Honorário</MDTypography>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome}
                                    value={tipoHonorarioOptions.find(t => t.id === addForm.tipoHonorario) || null}
                                    options={tipoHonorarioOptions}
                                    onChange={(val) => {
                                        const selectedTipo = val ? val.id : 5;
                                        const selectedObj = tipoHonorarioOptions.find(t => t.id === selectedTipo);
                                        setAddForm({ 
                                            ...addForm, 
                                            tipoHonorario: selectedTipo, 
                                            titulo: selectedObj ? selectedObj.nome : "Honorários" 
                                        });
                                    }}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color="text" display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Valor do Débito (R$) *</MDTypography>
                                <MDInput
                                    type="number"
                                    fullWidth
                                    size="small"
                                    value={addForm.valorOriginal}
                                    onChange={(e) => setAddForm({ ...addForm, valorOriginal: e.target.value })}
                                    placeholder="0.00"
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color="text" display="block" sx={{ minHeight: "22px", mb: 0.5 }}>Vencimento</MDTypography>
                                <MDTextFieldCalendar
                                    type="date"
                                    value={addForm.vencimento}
                                    onChange={(e) => setAddForm({ ...addForm, vencimento: e.target.value })}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    darkMode={darkMode}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12}>
                            <MDBox mb={1}>
                                <MDTypography variant="caption" fontWeight="medium" color="text">Observação / Descrição</MDTypography>
                                <MDInput
                                    fullWidth
                                    multiline
                                    rows={2}
                                    value={addForm.descricao}
                                    onChange={(e) => setAddForm({ ...addForm, descricao: e.target.value })}
                                    placeholder="Observações adicionais..."
                                />
                            </MDBox>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2, borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : undefined }}>
                    <MDButton 
                        variant="outlined" 
                        color="secondary" 
                        onClick={() => setAddModalOpen(false)} 
                        disabled={isSaving}
                        sx={{
                            color: darkMode ? "#ffffff !important" : undefined,
                            borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined
                        }}
                    >
                        Cancelar
                    </MDButton>
                    <MDButton 
                        variant="contained" 
                        color="info" 
                        onClick={handleSaveAdd} 
                        disabled={isSaving}
                        sx={{
                            backgroundColor: darkMode ? "#007bff !important" : undefined,
                            color: "#ffffff !important",
                            fontWeight: "bold"
                        }}
                    >
                        {isSaving ? <CircularProgress size={20} color="inherit" /> : "Salvar Honorário Avulso"}
                    </MDButton>
                </DialogActions>
            </Dialog>

            <MDSnackbar
                color="success"
                icon="check"
                title="Sucesso"
                content={sbMessage}
                dateTime=""
                open={successSB}
                onClose={() => setSuccessSB(false)}
                close={() => setSuccessSB(false)}
                bgWhite
            />
            <MDSnackbar
                color="error"
                icon="warning"
                title="Erro"
                content={sbMessage}
                dateTime=""
                open={errorSB}
                onClose={() => setErrorSB(false)}
                close={() => setErrorSB(false)}
                bgWhite
            />
        </MDBox>
    );
}
